import { useCallback } from 'react';

import type { PasswordReset } from 'state/__generated__/tadaahAPI';
import { useApiResetPasswordCreate } from 'state/__generated__/tadaahAPI';

type UseFreelancerForgotPasswordHandler = {
  forgotPassword: (values: PasswordReset) => Promise<void>;
  initialValues: PasswordReset;
  isLoading: boolean;
  error: Error | null;
};

const initialValues = { email: '' };
const useFreelancerForgotPassword = (): UseFreelancerForgotPasswordHandler => {
  const { mutateAsync, error, isLoading } = useApiResetPasswordCreate<Error>({
    mutation: {
      mutationKey: 'freelancer-reset-password',
    },
  });

  const forgotPassword = useCallback(
    async (values: PasswordReset) => {
      await mutateAsync({ data: values });
    },
    [mutateAsync],
  );

  return { error, forgotPassword, initialValues, isLoading };
};

export default useFreelancerForgotPassword;
